import { setForceToUpdateTagList } from '@src/reducers/tags';
import { getForceToUpdateTagList } from '@src/selectors/tags';
import type { RootState } from '@src/store/reduxstore';
import useWindowSize from '@src/utils/useWindowSize';
import { RefObject, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useIsVisible from './useIsVisible';

const useOverflowYItems = (
  divRef: RefObject<HTMLDivElement>,
  height: number,
  gap: number
) => {
  const dispatch = useDispatch();
  const [windowWidth, windowHeight] = useWindowSize();
  const isVisible = useIsVisible(divRef);

  const [totalVisibleItems, setTotalVisibleItems] = useState(0);
  const [widthVisibleElements, setWidthVisibleElements] = useState(0);
  const [leftWidth, setLeftWidth] = useState(0);

  const isContextMenuOpened = useSelector(
    (state: RootState) => state.agentConsole.chatContextMenu.isOpened
  );
  const forceToUpdateTagsList = useSelector(getForceToUpdateTagList);

  useEffect(() => {
    if (!divRef.current || !isVisible) return;

    setTotalVisibleItems(0);
    dispatch(setForceToUpdateTagList(false));
    const elements = Array.from((divRef.current as HTMLDivElement).children);
    if (!elements.length) return;

    const [first] = elements;
    const yCoord = first.getBoundingClientRect().top;
    let lastVisibleIndex = 0;
    let increaseLeftWidth = 0;

    elements.forEach((ele, ind) => {
      const curYCoord = ele.getBoundingClientRect().top;
      if (curYCoord <= yCoord + height) {
        setTotalVisibleItems(prev => prev + 1);
        lastVisibleIndex = ind;
        increaseLeftWidth += ele.clientWidth + gap;
      }
    });

    const { x, width } = elements[lastVisibleIndex].getBoundingClientRect();
    setWidthVisibleElements(x + width);
    setLeftWidth(increaseLeftWidth);
  }, [
    windowWidth,
    windowHeight,
    divRef,
    height,
    isContextMenuOpened,
    forceToUpdateTagsList,
    dispatch,
    isVisible,
    gap,
  ]);

  return { totalVisibleItems, widthVisibleElements, leftWidth };
};

export default useOverflowYItems;
